<template>
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-form-item>
                <el-select v-model="filters.isautosyn" placeholder="自动同步数据" clearable>
                    <el-option v-for="item in isAutoSynDataOptions" :label="item.label" :key="item.value" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input v-model="filters.searchKeys" placeholder="请输入客户标识/客户名称/应用代码" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" v-on:click="getCompanyApiConfigs">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleAdd">新增配置</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="apiconfigs" highlight-current-row v-loading="listLoading" style="width: 100%;">
        <el-table-column prop="apicode" label="客户标识" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="apiname" label="客户名称" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="appcode" label="应用代码" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="apppwd" label="应用秘钥" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="isautosyn" label="自动同步" min-width="150" sortable>
            <template scope="scope">
                <el-tag :type="scope.row.isautosyn == 0 ? 'gray' : scope.row.isautosyn == 1 ? 'primary' : 'warning'" close-transition>{{scope.row.isautosyn == 0 ? '否' : scope.row.isautosyn == 1 ? '是' : '未知' }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="gprspool" label="启用流量池" min-width="150" sortable>
            <template scope="scope">
                <el-tag :type="scope.row.gprspool == 0 ? 'gray' : scope.row.gprspool == 1 ? 'primary' : 'warning'" close-transition>{{scope.row.gprspool == 0 ? '否' : scope.row.gprspool == 1 ? '是' : '未知' }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="openmonthflow" label="启用断网阀值扫描" min-width="160" sortable>
            <template scope="scope">
                <el-tag :type="scope.row.openmonthflow == 0 ? 'gray' : scope.row.openmonthflow == 1 ? 'primary' : 'warning'" close-transition>{{scope.row.openmonthflow == 0 ? '否' : scope.row.openmonthflow == 1 ? '是' : '未知' }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="usedgprsmore" label="已用卡流量倍数" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="addtime" label="注册日期" min-width="180" sortable>
            <template scope="scope">
                <el-icon name="time"></el-icon>
                <span>{{ scope.row.addtime }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="flowThreshold" label="流量阈值(MB)" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="cardnum" label="卡总量" min-width="150" sortable>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
            <template scope="scope">
				<el-button size="small" @click="downloadCardExcel(scope.$index, scope.row)">下载</el-button>
                <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑API配置" :visible.sync="editFormVisible" :close-on-click-modal="false" @close="editFormHandleClose">
        <el-form :model="editForm" label-width="150px" :rules="editFormRules" ref="editForm">
            <el-form-item label="客户标识：" prop="apicode">
                <el-input v-model="editForm.apicode" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="客户名称：" prop="apiname">
                <el-input v-model="editForm.apiname" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="应用代码：" prop="appcode">
                <el-input v-model="editForm.appcode" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="应用秘钥：" prop="apppwd">
                <el-input v-model="editForm.apppwd" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="自动同步数据：" prop="isautosyn">
                <el-select v-model="editForm.isautosyn" placeholder="自动同步数据" clearable style="width:100%">
                    <el-option v-for="item in isAutoSynDataOptions" :label="item.label" :key="item.value" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="已用卡流量倍数：" prop="usedgprsmore">
                <el-input v-model="editForm.usedgprsmore" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="启用流量池：" prop="gprspool">
                <el-select v-model="editForm.gprspool" placeholder="启用流量池" clearable style="width:100%">
                    <el-option v-for="item in isUsedGprsPoolDataOptions" :label="item.label" :key="item.value" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="启用断网阀值扫描：" prop="openmonthflow">
                <el-select v-model="editForm.openmonthflow" placeholder="启用断网阀值扫描" clearable style="width:100%">
                    <el-option v-for="item in isUsedOpenmonthflowDataOptions" :label="item.label" :key="item.value" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="流量阀值(MB)" prop="flowThreshold">
                <el-input v-model="editForm.flowThreshold" auto-complete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="editFormHandleClose">取消</el-button>
            <el-button type="primary" @click.native="editSubmit" :loading="addLoading">保存</el-button>
        </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增API配置" :visible.sync="addFormVisible" :close-on-click-modal="false" @close="addFormHandleClose">
        <el-form :model="addForm" label-width="150px" :rules="addFormRules" ref="addForm">
            <el-form-item label="客户标识：" prop="apicode">
                <el-input v-model="addForm.apicode" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="客户名称：" prop="apiname">
                <el-input v-model="addForm.apiname" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="应用代码：" prop="appcode">
                <el-input v-model="addForm.appcode" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="应用秘钥：" prop="apppwd">
                <el-input v-model="addForm.apppwd" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="自动同步数据：" prop="isautosyn">
                <el-select v-model="addForm.isautosyn" placeholder="自动同步数据" clearable style="width:100%">
                    <el-option v-for="item in isAutoSynDataOptions" :label="item.label" :key="item.value" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="已用卡流量倍数：" prop="usedgprsmore">
                <el-input v-model="addForm.usedgprsmore" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="启用流量池：" prop="gprspool">
                <el-select v-model="addForm.gprspool" placeholder="启用流量池" clearable style="width:100%">
                    <el-option v-for="item in isUsedGprsPoolDataOptions" :label="item.label" :key="item.value" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="启用断网阀值扫描：" prop="openmonthflow">
                <el-select v-model="addForm.openmonthflow" placeholder="启用断网阀值扫描" clearable style="width:100%">
                    <el-option v-for="item in isUsedOpenmonthflowDataOptions" :label="item.label" :key="item.value" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="流量阀值(MB)" prop="flowThreshold">
                <el-input v-model="addForm.flowThreshold" auto-complete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="addFormHandleClose">取消</el-button>
            <el-button type="primary" @click.native="addSubmit" :loading="addLoading">保存</el-button>
        </div>
    </el-dialog>
</section>
</template>

<script>
import util from '../../common/js/util'
import constant from '../../common/js/constant'
//import NProgress from 'nprogress'
import {
    getCompanyApiconfigListPage,
    editCompanyApiconfig,
    addCompanyApiconfig
} from '../../api/api';

export default {
    data() {
        //检查价格
        var validateflowThreshold = (rule, value, callback) => {
            if (value == null || value.trim() == '') {
                return callback(new Error('请输入流量阀值'));
            }
            var reg = /^[0-9]{1,30}([.][0-9]{1,2})?$/;
            if (!reg.test(value)) {
                return callback(new Error('流量阀值格式不正确(数字类型，大于0，小数点后两位)'));
            } else {
                return callback();
            }
        }
        return {
            dialogVisible: false,
            //查询过滤条件
            filters: {
                //是否自动同步数据
                isautosyn: '',
                //请输入客户标识/客户名称/应用代码
                searchKeys: ''
            },
            apiconfigs: [], //分页数据
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            listLoading: false,
            isAutoSynDataOptions: [{
                    value: "0",
                    label: '否'
                },
                {
                    value: "1",
                    label: '是'
                }
            ], //是否自动同步数据下拉框选项列表
            isUsedGprsPoolDataOptions: [{
                    value: "0",
                    label: '否'
                },
                {
                    value: "1",
                    label: '是'
                }
            ], //是否启用流量池下拉框选项列表

            isUsedOpenmonthflowDataOptions: [{
                    value: "0",
                    label: '否'
                },
                {
                    value: "1",
                    label: '是'
                }
            ], //是否启用流量池下拉框选项列表

            editFormVisible: false, //编辑界面是否显示
            editLoading: false,
            editFormRules: {
                apicode: [{
                    required: true,
                    message: '请输入客户标识',
                    trigger: 'blur'
                }],
                apiname: [{
                    required: true,
                    message: '请输入客户名称',
                    trigger: 'blur'
                }],
                appcode: [{
                    required: true,
                    message: '请输入应用代码',
                    trigger: 'blur'
                }],
                apppwd: [{
                    required: true,
                    message: '请输入应用秘钥',
                    trigger: 'blur'
                }],
                isautosyn: [{
                    required: true,
                    message: '请选择自动同步',
                    trigger: 'change'
                }],
                usedgprsmore: [{
                    required: true,
                    message: '请输入已用卡流量倍数,必须为数字',
                    trigger: 'blur'
                }],
                gprspool: [{
                    required: true,
                    message: '请选择流量池',
                    trigger: 'change'
                }, ],
                openmonthflow: [{
                    required: true,
                    message: '请选择断网阀值',
                    trigger: 'change'
                }, ],
                flowThreshold: [
                    // {
                    //     required: true,
                    //     message: '请输入流量阀值',
                    //     trigger: 'change'
                    // },
                    {
                        required: true,
                        validator: validateflowThreshold,
                        trigger: 'blur'
                    }
                ]
            },
            //编辑界面数据
            editForm: {
                apicode: '',
                apiname: '',
                appcode: '',
                apppwd: '',
                isautosyn: '',
                usedgprsmore: '',
                gprspool: '',
                flowThreshold: '',
                openmonthflow:''
            },

            addFormVisible: false, //新增界面是否显示
            addLoading: false,
            addFormRules: {
                apicode: [{
                    required: true,
                    message: '请输入客户标识,必须保证唯一性',
                    trigger: 'blur'
                }],
                apiname: [{
                    required: true,
                    message: '请输入客户名称',
                    trigger: 'blur'
                }],
                appcode: [{
                    required: true,
                    message: '请输入应用代码',
                    trigger: 'blur'
                }],
                apppwd: [{
                    required: true,
                    message: '请输入应用秘钥',
                    trigger: 'blur'
                }],
                isautosyn: [{
                    required: true,
                    message: '请选择自动同步',
                    trigger: 'change'
                }],
                usedgprsmore: [{
                    required: true,
                    message: '请输入已用卡流量倍数,必须为数字',
                    trigger: 'blur'
                }],
                gprspool: [{
                    required: true,
                    message: '请选择流量池',
                    trigger: 'change'
                }],
                openmonthflow: [{
                    required: true,
                    message: '请选择断网阀值',
                    trigger: 'change'
                }, ],
                flowThreshold: [
                    // {
                    //     required: true,
                    //     message: '请输入流量阀值',
                    //     trigger: 'change'
                    // },
                    {
                        required: true,
                        validator: validateflowThreshold,
                        trigger: 'blur'
                    }
                ]
            },
            //新增界面数据
            addForm: {
                apicode: '',
                apiname: '',
                appcode: '',
                apppwd: '',
                isautosyn: '1',
                usedgprsmore: '1',
                gprspool: '0',
                openmonthflow:'0'
            }

        }
    },
    methods: {
        //是否同步数据显示转换
        formatIsAotoSynData: function (row, column) {
            return row.isautosyn == 1 ? '是' : row.userlevel == 2 ? '否' : '未知';
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCompanyApiConfigs();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCompanyApiConfigs();
        },
        //获取集团客户API配置列表
        getCompanyApiConfigs() {
            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };

            para = Object.assign(para, this.filters);

            this.listLoading = true;
            //NProgress.start();
            getCompanyApiconfigListPage(para).then((res) => {
                this.total = res.data.total;
                this.apiconfigs = res.data.list;
                this.listLoading = false;
                //NProgress.done();
            });
		},
		downloadCardExcel:function(index, row){
			let para = "apicode="+row.apicode;
			location.href = "/api/companyapiconfig/download/cards?" + para;
		},
        //显示编辑界面
        handleEdit: function (index, row) {
            this.editFormVisible = true;
            this.editForm = Object.assign({}, row);
        },
        //显示新增界面
        handleAdd: function () {
            this.addFormVisible = true;
        },
        //关闭新增配置界面触发
        addFormHandleClose: function (done) {
            this.$refs['addForm'].resetFields();
            //done();
            this.addFormVisible = false;
        },
        //关闭编辑配置界面触发
        editFormHandleClose: function (done) {
            this.$refs['editForm'].resetFields();
            //done();
            this.editFormVisible = false;
        },
        //编辑
        editSubmit: function () {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.editLoading = true;
                        //NProgress.start();
                        let para = Object.assign({}, this.editForm);
                        editCompanyApiconfig(para).then((res) => {
                            this.editLoading = false;
                            //NProgress.done();
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.$refs['editForm'].resetFields();
                            this.editFormVisible = false;
                            this.getCompanyApiConfigs();
                        });
                    });
                }
            });
        },
        //新增
        addSubmit: function () {
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.addLoading = true;
                        //NProgress.start();
                        let para = Object.assign({}, this.addForm);
                        addCompanyApiconfig(para).then((res) => {
                            this.addLoading = false;
                            //NProgress.done();

                            let {
                                msg,
                                code
                            } = res;
                            if (code !== 0) {
                                this.$message({
                                    message: msg,
                                    type: 'error'
                                });
                            } else {
                                this.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                                this.$refs['addForm'].resetFields();
                                this.addFormVisible = false;
                                this.getCompanyApiConfigs();
                            }

                        });
                    });
                }
            });
        }

    },
    mounted() {
        this.getCompanyApiConfigs();
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// company_group.vue?2ed68d57